import { FC } from "react";
import Loader from "../../../../../../../common/components/molecule/Loader/Loader";
import EmptyListIcon from "../../../../../../../common/components/molecule/Table/EmptyListIcon/EmptyListIcon";

export interface LinkListViewProps {

  listItemView?: FC[] 
  isLoading?: boolean

}

export default function LinkListView(
  {
    listItemView,
    isLoading
  } : LinkListViewProps
) {


  if(isLoading) {
    return (
      <Loader color="white" centered/>
    );
  }

  if (!listItemView || listItemView.length === 0) {
    return (
      <EmptyListIcon message="Aucune liaison trouvée"/>
    );
  }

  return (
    <div >
      {listItemView?.map((ItemView, index) => (
        <div style={{marginBottom: 15}}>
        <ItemView key={index} />
        </div>
      ))}
    </div>
  );
}


